import { makeStyles } from "@material-ui/core/styles";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/material.css";
import { normalizeMobileNumber } from "../../logic/phone";
import { rv } from "../../tokens";
import { AlertCircleIcon } from "../icons";

const useStyles = makeStyles((theme) => ({
  root: { marginBottom: theme.spacing(0.5) },
  label: {
    display: "block",
    fontSize: 11,
    fontWeight: 600,
    textTransform: "uppercase",
    letterSpacing: ".04em",
    color: rv.muted,
    marginBottom: 7,
  },
  phone: {
    "& .react-tel-input": {
      position: "relative",
      width: "100%",
      border: `1.5px solid ${rv.inputStroke}`,
      borderRadius: rv.radiusInput,
      background: "#fff",
      boxSizing: "border-box",
    },
    "& .react-tel-input:focus-within": {
      borderColor: rv.green,
      boxShadow: "0 0 0 3px rgba(37,97,65,.12)",
    },
    "& .rv-phone-input": {
      width: "100% !important",
      height: "44px !important",
      border: "0 !important",
      borderRadius: `${rv.radiusInput}px !important`,
      fontFamily: rv.fontSans,
      fontSize: "14px !important",
      boxShadow: "none !important",
      paddingLeft: "84px !important",
      background: "transparent !important",
    },
    "& .flag-dropdown": {
      border: "0 !important",
      borderRight: `1px solid ${rv.inputStroke} !important`,
      borderRadius: `${rv.radiusInput}px 0 0 ${rv.radiusInput}px !important`,
      background: "#fff !important",
      top: "0 !important",
      bottom: "0 !important",
      left: "0 !important",
      width: "72px",
    },
    "& .selected-flag": {
      width: "72px !important",
      paddingLeft: "12px !important",
      background: "#fff !important",
      borderRadius: `${rv.radiusInput}px 0 0 ${rv.radiusInput}px !important`,
    },
  },
  error: {
    display: "flex",
    alignItems: "center",
    gap: 5,
    color: rv.errorFg,
    fontSize: 11.5,
    fontWeight: 500,
    marginTop: 5,
  },
}));

interface Props {
  label?: string;
  value: string | undefined;
  onChange: (value: string) => void;
  error?: string;
  required?: boolean;
}

export default function PhoneFieldPH({
  label,
  value,
  onChange,
  error,
  required,
}: Props) {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      {label && (
        <label className={classes.label}>
          {label}
          {required && <span style={{ color: rv.errorFg }}> *</span>}
        </label>
      )}
      <div className={classes.phone}>
        <PhoneInput
          country="ph"
          masks={{ ph: "(...) ... ...." }}
          containerStyle={{ width: "100%" }}
          inputClass="rv-phone-input"
          specialLabel=""
          countryCodeEditable={false}
          value={value || ""}
          onChange={(phoneValue, country) =>
            onChange(
              normalizeMobileNumber(
                phoneValue,
                country as { countryCode?: string }
              )
            )
          }
        />
      </div>
      {error && (
        <span className={classes.error} data-rv-error="true">
          <AlertCircleIcon size={13} />
          {error}
        </span>
      )}
    </div>
  );
}
